import { render } from "./Salle4Fr.vue?vue&type=template&id=234f30d6"
import script from "./Salle4Fr.vue?vue&type=script&lang=js"
export * from "./Salle4Fr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__